import { 
  GET_REVIEW_MODE,
} from '../constants/Constants';
  
  const initalState = {
    docId : null,
    reviewId: null,
    approvalId: null,
    dsearId: null
  }
  
  export const getPersonalHubReducer = (state = initalState, action = {}) => {
        return {
          ...state,
          [action.type]: action.payload,
    }
  }